<template>
<div class="chapter">
<div class="inner_page">
<div class="frontmatter" id="fm1">
<p class="aqh">The barghest crouched in front of me,<br/>ready to fight.</p>
<p class="aqtx1">We raised our shields almost simultaneously and then seamlessly blended them together, my water flowing through his combined air and earth to create a wall of elemental force that was virtually impenetrable.</p>
<p class="aqtx">Which was lucky, as right then a blast of fire streaked across the pasture toward Anyan. It was red and angry, and it was backed up by a pummeling wave of power so fierce that even behind our übershield I staggered under its onslaught.</p>
<p class="aqtx">I went to one knee but no farther, for Anyan was there, bracing me with his massive shoulder. Engulfed in fire, we barely kept it at bay with our shields. We were as yet unharmed, but fire and snapping energy were everywhere.</p>
<p class="aqtx">Only then did my dazzled brain put together what had just happened.</p>
<p class="aqtx">I may have fled Boston for my own safety, but all I'd accomplished was bringing danger directly to Rockabill and the people I loved.</p>
<p class="aqh">Praise for <em>T</em><span class="smallcap"><em>EMPEST</em></span> <em>R</em><span class="smallcap"><em>ISING:</em></span></p>
<p class="fsq">“A fascinating, fast-paced, sexy storm of a book.”</p>
<p class="fsqs">—Rachel Caine</p>
<p class="fsq">“Witty and fun, with a dash of dark suspense.”</p>
<p class="fsqs">—<a class="pubhlink" href="http://Scifichick.com" target="_blank">Scifichick.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780316076012_epub_fm1_r1.vue?ab4082e0